export abstract class ExecutionState<T, U = T> {
    abstract initState(): Promise<void>;
    abstract setState(jobsExecution: T[]): void;
    abstract getState(): U[];
    abstract removeFromState(jobExecutionId: number): void;
}
